import React, {useState} from 'react';
import {useQuery} from "react-query";
import ngage from "services/ngage";
import Page from "components/Page";
import {Table, TableBody, TableData, TableHead, TableHeader, TableRow} from "components/Table";
import {ChatIcon} from "@heroicons/react/outline";
import Button from "components/Button";
import {PlusIcon} from "@heroicons/react/solid";
import {useNavigate} from "react-router-dom";
import {useAuth} from "context/AuthContext";
import NotAuthorised from "pages/NotAuthorised";
import ConversationContextMenu from "components/menus/ConversationContextMenu";
import {formattedDateTime} from "../../../services/date";
import DeleteConversation from "../Delete";
import {Conversation} from "../../../types/Conversation";
import FeatureFlag from "../../../types/FeatureFlag";

// Component ----

function ConversationList() {
  const auth = useAuth();
  const navigate = useNavigate();
  const canUseAIChatbot = auth.canUse(FeatureFlag.AIChatbot);

  const [deletingConversation, setDeletingConversation] = useState<Conversation | null>(null);
  const [page, setPage] = useState<number>(1);

  const {data: conversations, isLoading: conversationsLoading} = useQuery(
    ['conversations.all', {page, per_page: 50}],
    () => ngage.conversations.filtered({page, per_page: 50}),
    {keepPreviousData: true, enabled: canUseAIChatbot /*&& auth.can('exhibits:read')*/} // TODO: Add conversations permissions
  )

  // Prevent unauthorised viewing
  // TODO: Add conversations permissions
  if (!canUseAIChatbot /*|| auth.cannot('exhibits:read')*/) {
    return <NotAuthorised/>
  }

  // Prepare page actions and breadcrumbs
  const actions = (
    <>
      {/* TODO: Add conversation permissions */}
      {/*{auth.can('exhibits:write') &&*/}
        <Button icon={PlusIcon} onClick={() => navigate('/conversations/new')}>New</Button>
      {/*}*/}
    </>
  )

  const breadcrumbs = {'Conversations': '/conversations'};

  return (
    <Page
      title='All Conversations'
      actions={actions}
      breadcrumbs={breadcrumbs}
      isLoading={conversationsLoading}
    >
      <div className="flex flex-col gap-5">
        <Table paginationData={conversations} setPage={setPage}>
        <TableHead>
          <TableRow>
            <TableHeader>Name</TableHeader>
            <TableHeader>Tokens used</TableHeader>
            <TableHeader>Created</TableHeader>
            <TableHeader/>
          </TableRow>
        </TableHead>

        <TableBody isLoading={conversationsLoading}>

          {conversations && conversations?.data.length < 1 ?
            <TableRow index={0}>
              <TableData colSpan={9}>
                <div className="py-4 flex flex-col justify-center items-center">
                  <ChatIcon className="h-8 w-8 text-gray-400 mb-2"/>
                  <span className="text-sm font-medium text-gray-600">No Conversations</span>
                </div>
              </TableData>
            </TableRow>
            : conversations?.data.map((conversation, index) => (
              <TableRow key={conversation.id} index={index}>
                <TableData>
                  <span className="flex">
                    <ChatIcon className="h-5 w-5 mr-2 text-gray-500"/> {conversation.title}
                  </span>
                </TableData>
                <TableData>{conversation.tokens_used.toLocaleString()}</TableData>
                <TableData>{formattedDateTime(conversation.created_at)}</TableData>
                <TableData alignment={TableData.alignments.RIGHT}>
                  <ConversationContextMenu
                    conversation={conversation}
                    onDeleteConversation={() => setDeletingConversation(conversation)}
                  />
                </TableData>

                {/* Delete confirmation modal */}
                <DeleteConversation
                  conversation={deletingConversation}
                  show={conversation === deletingConversation}
                  onCancel={() => setDeletingConversation(null)}
                  onDeleteFail={() => setDeletingConversation(null)}
                />
              </TableRow>
            ))}

        </TableBody>
      </Table>
      </div>
    </Page>
  );
}

export default ConversationList;